module.exports = __webpack_public_path__ + "img/windows.bf753cb8.svg";